import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import coupon from './views/coupon/coupon'
import storedValueWallet from './views/stored-value-wallet/stored-value-wallet'
import mySetUp from './views/my-set-up/my-set-up'
import storedValueWalletInfo from './views/stored-value-wallet/stored-value-wallet-info'

export default [
  {
    path: RoutePathConstants.COUPON,
    name: 'coupon',
    component: coupon
  },
  {
    path: RoutePathConstants.STORED_VALUE_WALLET,
    name: 'storedValueWallet',
    component: storedValueWallet
  },
  {
    path: RoutePathConstants.MYSETUP,
    name: 'mySetUp',
    component: mySetUp
  },
  {
    path: RoutePathConstants.STORED_VALUE_WALLET_INFO,
    name: 'storedValueWalletInfo',
    component: storedValueWalletInfo
  }
]


// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/page-mail-my/routers.js